import React from 'react';
import './style.css';
const MaterialDetails = ({ selectedMaterial }) => {
  return (
    <div className="selected_material_details">
      <p className="text">Datos del materail</p>
      <p className="text">
        <strong>Tipo:</strong> {selectedMaterial.Tipo}
      </p>
      <p className="text">
        <strong>Subtipo:</strong> {selectedMaterial.Subtipo}
      </p>
      <p className="text">
        <strong>Factor Daños Materiales:</strong> {selectedMaterial.factorDanosMateriales}
      </p>
      <p className="text">
        <strong>Factor Robo y Expoliación:</strong> {selectedMaterial.FactorRoboYExpoliacion}
      </p>
      {selectedMaterial.Descripcion && (
        <p className="text">
          <strong>Descripción:</strong> {selectedMaterial.Descripcion}
        </p>
      )}
    </div>
  );
};

export default MaterialDetails;
